export default {
  siteName:'Gymme Performance',
  minSiteMame:'EUI',
  tokenKey: 'Authorization',//存在sessionStorage里面的tokenKey
  postStatus:{
      draft:'草稿',
      published:'发布',
      recycled:"垃圾"
  },
  postType:{
      AR:'AR资讯',
      HEALTH:'健康资讯',
  },
  sex:{
      male:'男',
      female:'女',
      unknown:'未知'
  }
}
